export default "__VITE_ASSET__HG11tgoS__"